// extracted by mini-css-extract-plugin
module.exports = {"lds-roller":"style_lds-roller__mANmi"};